<template>
  <router-link
    :to="{ name: blocked ? 'plans' : route, params }"
    class="lesson-img text-decoration-none"
  >
    <div
      class="img"
      :style="lesson.is_on ? '' : `background-image: url(${lesson.picture})`"
    >
      <div class="icon-wrapper" :class="{ blocked }">
        <i :class="{ 'icon-lock': blocked, 'icon-play ml-1': !blocked }"></i>
      </div>
    </div>

    <div class="d-flex justify-content-between footer align-items-center pt-2">
      <strong>Aula {{ lesson.number }}</strong>
      <small>{{ lesson.duration }}</small>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    lesson: {
      type: Object,
      default: () => ({})
    },
    routeParams: {
      type: Object,
      default: null
    },
    route: {
      type: String,
      default: "lesson"
    }
  },
  computed: {
    blocked() {
      return (
        this.route === "lesson" && !this.lesson.is_free && !this.$user.hasCof
      );
    },
    params() {
      return this.routeParams
        ? this.routeParams
        : this.route === "lesson"
        ? { ...this.lesson }
        : { lesson: this.lesson.id };
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-img {
  width: 100%;

  .img {
    background-color: black;
    width: 100%;
    height: 0;
    padding-bottom: 60%;
    background-size: cover;
    position: relative;
  }

  .icon-wrapper {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 72px;
    min-width: 72px;
    max-height: 72px;
    min-height: 72px;
    border-radius: 72px;
    font-size: 36px;
    background: transparent;
    border: 3px solid #fdfdfd;
    text-shadow: 0 0 10px #272d32;

    &.blocked {
      border-color: rgba(215, 215, 215, 0.8);
      background: rgba(215, 215, 215, 0.8);
    }
  }

  .footer {
    strong {
      font-weight: bold;
      color: #272d32;
      font-size: 14px;
      line-height: 14px;
    }

    small {
      font-weight: normal;
      font-size: 12px;
      line-height: 12px;
      color: #979797;
    }
  }
}
</style>
